<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden">
    <BreadcrumbMenu pageTitle="category" />

    <CategoryList
      :categories="filteredCategories"
      :search-query="searchQuery"
      :pagination-config="paginationConfig"
      @update:search-query="searchQuery = $event"
      @create="openCreateModal"
      @edit="openEditModal"
      @delete="deleteCategory"
    />

    <div class="flex-grow-1"></div>
    <MainFooter />

    <CreateCategoryModal
      :open="showModal"
      :is-edit="!!selectedCategory"
      :form="form"
      :errors="errors"
      :loading="loading"
      :preview-url="previewUrl"
      @close="closeModal"
      @save="saveCategory"
      @generate-code="generateCategoryCode"
      @update-field="updateField"
      @file-change="handleFileUpload"
      @remove-image="removeImage"
    />
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from "vue";

import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";
import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import CreateCategoryModal from "../../components/Settings/Category/CreateCategoryModal.vue";
import CategoryList from "../../components/Settings/Category/CategoryList.vue";
import { useCategory } from "../../composables/useCategory";

const {
  searchQuery,
  filteredCategories,
  showModal,
  selectedCategory,
  form,
  errors,
  loading,
  previewUrl,
  paginationConfig,
  fetchCategories,
  openCreateModal,
  openEditModal,
  closeModal,
  updateField,
  handleFileUpload,
  removeImage,
  generateCategoryCode,
  saveCategory,
  deleteCategory,
} = useCategory();

onMounted(fetchCategories);
</script>
